import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Edition = makeShortcode("Edition");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "rest-api-overview"
    }}>{`REST API Overview`}</h1>
    <p>{`The REST API documentation describes the REST APIs that are available in Adobe Commerce (PaaS) and Adobe Commerce as a Cloud Service (SaaS).`}</p>
    <p>{`The APIs can be used to perform a wide array of tasks. For example:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Create a shopping app. This can be a traditional app that a user downloads on a mobile device. You could also create an app that an employee uses on a showroom floor to help customers make purchases.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Integrate with CRM (Customer Relationship Management) or ERP (Enterprise Resource Planning) backend systems, such as Salesforce or Xero.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Integrate with a CMS (Content Management System). Currently, content tagging is not supported.`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "adobe-commerce"
    }}>{`Adobe Commerce`}</h2>
    <Edition name="paas" mdxType="Edition" />
    <p><a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/en/docs/commerce-on-cloud/user-guide/overview?lang=en"
      }}>{`Adobe Commerce on Cloud`}</a>{`, Adobe Commerce on-premises, and `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/magento-open-source/user-guide/overview/overview.html?lang=en"
      }}>{`Magento Open Source`}</a>{` all use the same REST API framework. The REST API documentation describes the REST APIs that are available in these versions of Adobe Commerce and Magento Open Source.`}</p>
    <h3 {...{
      "id": "endpoints"
    }}>{`Endpoints`}</h3>
    <p>{`Adobe Commerce provides a wide range of REST API endpoints that allow you to perform actions on behalf of Commerce administrators, customers, and guest shoppers. Integrations are also supported.`}</p>
    <h3 {...{
      "id": "authentication"
    }}>{`Authentication`}</h3>
    <p>{`Adobe Commerce REST APIs support multiple `}<a parentName="p" {...{
        "href": "../get-started/authentication/index.md"
      }}>{`authentication methods`}</a>{`, including:`}</p>
    <ul>
      <li parentName="ul">{`Third-party applications authenticate with `}<a parentName="li" {...{
          "href": "../get-started/authentication/gs-authentication-oauth.md"
        }}>{`OAuth 1.0a`}</a>{`.`}</li>
      <li parentName="ul">{`Mobile applications authenticate using `}<a parentName="li" {...{
          "href": "../get-started/authentication/gs-authentication-token.md"
        }}>{`tokens`}</a>{`.`}</li>
      <li parentName="ul">{`Administrators and customers are authenticated with `}<a parentName="li" {...{
          "href": "../get-started/authentication/gs-authentication-token.md"
        }}>{`login credentials`}</a>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "url-structure"
    }}>{`URL structure`}</h3>
    <p>{`The URL for Adobe Commerce REST endpoints is structured as follows:`}</p>
    <p><inlineCode parentName="p">{`https://<host>/rest/<store-view-code>/<endpoint>`}</inlineCode></p>
    <h2 {...{
      "id": "adobe-commerce-as-a-cloud-service"
    }}>{`Adobe Commerce as a Cloud Service`}</h2>
    <Edition name="saas" mdxType="Edition" />
    <p>{`The Adobe Commerce as a Cloud Service REST API serves as a critical tool for extending and integrating commerce functionalities, but the endpoints available differ significantly from the REST APIs for Adobe Commerce on Cloud and on-premises deployments.`}</p>
    <p>{`The following key differences are important to consider when planning your REST API integrations with Adobe Commerce as a Cloud Service:`}</p>
    <h3 {...{
      "id": "endpoints-1"
    }}>{`Endpoints`}</h3>
    <p>{`Primarily the Cloud Service REST API differs in that it includes a smaller subset of endpoints. Specifically, the customer and guest REST APIs that are available in Adobe Commerce on Cloud and on-premises deployments are not available in Adobe Commerce as a Cloud Service. However, access to similar functionality remains available with the `}<a parentName="p" {...{
        "href": "../graphql/index.md"
      }}>{`GraphQL APIs`}</a>{`.`}</p>
    <p>{`The `}<a parentName="p" {...{
        "href": "../reference/rest/saas.md"
      }}>{`API reference`}</a>{` lists the available endpoints. -->`}</p>
    <h3 {...{
      "id": "authentication-1"
    }}>{`Authentication`}</h3>
    <p>{`In previous versions of Adobe Commerce, you would use authentication tokens to authorize your requests to the REST API. In Adobe Commerce as a Cloud Service, you must use Adobe Identity Management Service (IMS) to `}<a parentName="p" {...{
        "href": "./authentication/index.md"
      }}>{`authenticate your requests`}</a>{`.`}</p>
    <p>{`The authentication system supports both `}<a parentName="p" {...{
        "href": "./authentication/user.md"
      }}>{`interactive user-based workflows`}</a>{` and automated `}<a parentName="p" {...{
        "href": "./authentication/server-to-server.md"
      }}>{`server-to-server integrations`}</a>{`, ensuring secure and appropriate access for different use cases. Both of these authentication methods require every request to be signed with an IMS Access Token.`}</p>
    <h3 {...{
      "id": "url-structure-1"
    }}>{`URL structure`}</h3>
    <p>{`The URL structure for your REST endpoints will be slightly different in Adobe Commerce as a Cloud Service. In addition to your base URL changing, the route no longer contains the string `}<inlineCode parentName="p">{`/rest`}</inlineCode>{`, nor does it contain the store view code. The store view code is specified in the `}<inlineCode parentName="p">{`Store`}</inlineCode>{` header of the request.`}</p>
    <p>{`Cloud Service URLs use the following format:`}</p>
    <p><inlineCode parentName="p">{`https://<server>.api.commerce.adobe.com/<tenant-id>/<endpoint>`}</inlineCode></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      